



















































































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import {
  BootstrapVueRowDetails,
  FiservDebitCardInfo,
  FiservDebitCardStatus,
  FiservDebitCardsDetailLocation,
} from "@/shared/types";
import { useFiservDebitCardsStore } from "@/shared/store/fiservDebitCards";

@Component({
  components: {}
})
export default class FiservDebitCardActionMenu extends Vue {

  fivserveDebitCardStore = useFiservDebitCardsStore();

  @Prop()
  row: BootstrapVueRowDetails;

  @Prop()
  card: FiservDebitCardInfo;

  FiservDebitCardStatus = FiservDebitCardStatus;
  FiservDebitCardsDetailLocation = FiservDebitCardsDetailLocation;

  selected = FiservDebitCardsDetailLocation.ChangePinForm;

  mounted () {
    if (!this.card.isPinSet) {
      this.selected = FiservDebitCardsDetailLocation.SetPinForm;
    }
    if (this.card.cardStatus === FiservDebitCardStatus.ReplacementRequested) {
      this.selected = FiservDebitCardsDetailLocation.ConfirmReplacementForm;
    }
  }

  onSubmitChanges (e: Event) {
    e.preventDefault();
    this.fivserveDebitCardStore.setFiservDebitCardDetailLocation(this.selected);
  }

}
